module.exports = __webpack_public_path__ + "media/img/logos/2023/xmas-7905c2a57e17e17d6146f0f0b1452c25.svg";